export const width=150;export const height=308.24175824175825;export default{width:width,height:height};